app.controller("erro", function ($scope, $location) {
	$scope.url_inexistente = $location.path()
})
